import _ from "lodash";
import Baobab from "baobab";

import webPlayerState from "../state/webPlayerState";

export function buildPreviewSelectedOrgState(selectedOrg) {
	if (!_.isPlainObject(selectedOrg)) {
		return selectedOrg;
	}

	return {
		id: selectedOrg.id,
		member: selectedOrg.member || null
	};
}

export function buildPreviewWebPlayerState({
	user,
	selectedOrg,
	config = {}
} = {}) {
	const newWebPlayerState = new Baobab(_.cloneDeep(webPlayerState.get()));

	newWebPlayerState.set(["user"], user || {});
	if (selectedOrg) {
		newWebPlayerState.set(["selectedOrg"], buildPreviewSelectedOrgState(selectedOrg));
	}
	newWebPlayerState.set(["_config"], config);
	newWebPlayerState.set(["appPreferences", "checkbarLocation"], "hidden");

	const nextState = newWebPlayerState.get();
	delete nextState.timerTemplates;
	return nextState;
}
